import { LeftCircleOutlined } from '@ant-design/icons';
import { Row } from 'antd';
import { COProductCardPropsEnums } from 'enums/COProductCardEnums';
import { ProductDashboardChartsViewProps } from 'enums/ProductDashboardChartsEnums';
import React, { FC } from 'react';
import COButton from 'shared/components/COButton';
import styles from '../ProductDashboardCharts.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as ApprovalReportIcon } from 'assets/icons/app-report.svg';
import { Product } from 'models/Product/product.model';
import DashboardService from 'services/DashboardService/dashboard.service';

interface HeaderProps {
  newProduct?: Product;
}

const Header: FC<HeaderProps> = ({ newProduct }) => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };

  const { viewApprovalReport } = DashboardService();

  const { id: productId } = useParams();

  const viewReport = () => viewApprovalReport(productId);
  return (
    <>
      <Row className={styles.headerContainer}>
        <div onClick={handleGoBack}>
          <p className={styles.backButton}>
            <LeftCircleOutlined />
          </p>
        </div>
        <h1>{ProductDashboardChartsViewProps.HEADING}</h1>
        {newProduct?.status === COProductCardPropsEnums.APPROVED && (
          <div className={styles.approveBtn}>
            <COButton secondary onClick={viewReport}>
              <ApprovalReportIcon />
              {COProductCardPropsEnums.APPROVAL_REPORT}
            </COButton>
          </div>
        )}
      </Row>
      <Row>
        <h1>{newProduct?.name}</h1>
      </Row>
    </>
  );
};

export default Header;
